import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_create = createAsyncThunkSafe<string, void>(
  ENUM__network_event_client_to_server.WORKSPACE_CREATE,
  async (workspace): Promise<string> => {
    return await send_to_server<string>(ENUM__network_event_client_to_server.WORKSPACE_CREATE, workspace);
  },
);

export function init_remote_workspace_create(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_create.pending, (state, action) => {})
    .addCase(remote_workspace_create.rejected, (state, action) => {})
    .addCase(remote_workspace_create.fulfilled, (state, action: PayloadAction<string>) => {});
}
